let partyId = "",
  partyName ,
  consultantId,
  consultantName,
  consultantWebSite,
  consultantRegion,
  consultantMessage,
  consultantType,
  consultantList = [],
  renderedConsultantList = [],
  partyList = [],
  renderedPartyList = [];



function injectInputs(form, orderAttributes) {
  orderAttributes.forEach(({ key, value }) => {
    const $input = form.querySelector(
      `input[name="checkout[attributes][${key}]"]`
    );
    if (!$input) {
      const $newInput = document.createElement("input");
      $newInput.type = "hidden";
      $newInput.name = `checkout[attributes][${key}]`;
      $newInput.value = value;
      form.appendChild($newInput);
    }
  });
}

function hideConsultantFlow() {
  const consultantFlowContainer = document.querySelector("#pws-information");
  const consultantRepMessage = document.querySelector("#rep-message");
  const pwsTitle = document.querySelector("#pws-main-title");
  consultantFlowContainer.classList.add("hidden");
  consultantRepMessage.classList.add("hidden");
  pwsTitle.classList.add("hidden");
}

function showConsultantFlow() {
  const consultantFlowContainer = document.querySelector("#pws-information");
  const pwsTitle = document.querySelector("#pws-main-title");
  pwsTitle.classList.remove("hidden");
  consultantFlowContainer.classList.remove("hidden");

}

async function getCartAttributes() {
  let url = "/cart.js";
  try { 
    let res = await fetch(url);
    const cart = await res.json();
    return cart.attributes || {};
  } catch (error) {
    console.log(error);
  }
}

async function updateAttributes() {
  const cartAttributes = await getCartAttributes(); 
  const orderAttributes = [
    { key: "consultantId", value: getLocalStorage("twcid")  },
    { key: "partyId", value: getLocalStorage("twpid")},
    { key: "consultantOptIn", value: getLocalStorage("consultantoptIn") },
    { key: "partyOptIn", value: getLocalStorage("partyoptIn")},
    { key: "partyName", value: partyName },
    { key: "consultantName", value: consultantName },
    { key: "consultantWebSite", value: consultantWebSite },
    { key: "consultantType", value: consultantType },
    { key: "consultantRegion", value: consultantRegion }, 
    { key: "lang", value: cartAttributes["lang"] },
    { key: "Invoice Language", value: cartAttributes["Invoice Language"] },
    { key: "segment-clientID", value: cartAttributes["segment-clientID"] },
    { key: "google-clientID", value: cartAttributes["google-clientID"] },
    {
      key: "littledata_updatedAt",
      value: cartAttributes["littledata_updatedAt"],
    }, 
  ].filter(({ value }) => typeof value !== "undefined" && value !== null);
  const $cartForms = document.querySelectorAll(
    'form[method="post"].edit_checkout'
  );
  if ($cartForms.length) {
    $cartForms.forEach((form) => {
      injectInputs(form, orderAttributes);
    });
  }
}

function getLocalStorage(key) {
  return localStorage.getItem(key);
}

function getSessionStorage(key) {
  return sessionStorage.getItem(key);
}

function updateMessage(message, selector) {
  const messageElement = document.getElementById(selector);
  messageElement.innerHTML = message;
}

// const fetchConsultant = async (consultant) => {
//   const config = {
//     method: "GET",
//     headers: {
//       Accept: "application/json",
//     },
//   };

//   let BASE_URL = "https://soa.tupperware.com/twgb/shopify/jk/get/";
//   let COUNTRY_CODE = "US";

//   if (window.location.host.includes("tupperware.ca")) {
//     COUNTRY_CODE = "CA";
//   }
  
//   if (window.location.host.includes("pws-dev-us.myshopify.com")) {
//     BASE_URL = "https://soaqa.tupperware.com/twgb/shopify/jk/get";
//   }

//   if (window.location.host.includes("pws-dev-ca.myshopify.com")) {
//     COUNTRY_CODE = "CA";
//     BASE_URL = "https://soaqa.tupperware.com/twgb/shopify/jk/get";
//   }

//   const response = await searchConsultantById(consultant.consultantId)
//   const responseJson = await response.json()
//   const consultantDetails = responseJson.Account
//   console.log('consultantDetails', consultantDetails)
//   document.querySelector('.pws-consultant').style.display = 'block'
//   document.querySelector('#pws-consultant--initials').innerHTML = getInitials(consultantDetails.Name)
//   updateMessage(consultantDetails.Name, "pws-consultant--name");
//   updateMessage(consultantDetails.Title, "pws-consultant--sub");
//   updateMessage(`${consultantDetails.City} ${consultantDetails.State}`, "pws-consultant--local");
  
// };
const showModal = () => {
  const modalHTML = `
    <div class="modal" id="expireModal">
      <div class="modal-content">
        <span class="close-button" id="closeModal">&times;</span>
        <p>The party has expired.</p>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', modalHTML);

  const modal = document.getElementById('expireModal');
  const closeButton = document.getElementById('closeModal');

  modal.style.display = 'block';

  closeButton.addEventListener('click', () => {
    modal.style.display = 'none';
  });

  window.addEventListener('click', (event) => {
    if (event.target == modal) {
      modal.style.display = 'none';
    }
  });
};


const removeLocalStorage = () => {
  localStorage.removeItem("consultant");
  localStorage.removeItem("party");
  localStorage.removeItem("twcid");
  localStorage.removeItem("twpid");
}; 


async function getConsultantDetails(accountId){
  const config = {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
  }; 

  let BASE_URL = "https://soa.tupperware.com/twgb/shopify/jk/get";
  let COUNTRY_CODE = "US";

  // USCA-5431
  COUNTRY_CODE = window.Shopify.country;

  if (window.location.host.includes("tupperware.ca")) {
    COUNTRY_CODE = "CA"; 
  }
  
  if (window.location.host.includes("pws-dev-us.myshopify.com")) {
    BASE_URL = "https://soaqa.tupperware.com/twgb/shopify/jk/get";
  }

  if (window.location.host.includes("pws-dev-ca.myshopify.com")) {
    COUNTRY_CODE = "CA";
    BASE_URL = "https://soaqa.tupperware.com/twgb/shopify/jk/get";
  }
  let resp = await fetch(`${BASE_URL}/accountdetails/v1rs?Country=${COUNTRY_CODE}&AccountId=${accountId}`,config)
  if(!resp) return null
  const data = await resp.json() 
  const dataParsed = { 
    AccountStatus: data.Account.AccountStatus,
    consultantId:  data.Account.Code,
    consultantName: data.Account.Name,
    consultantRegion: data.Account.Region,
    consultantType: data.Account.AccountType,
    consultantWebSite: data.Account.WebSite,
    id: data.Account.Code,
    consultantState: data.Account.State,
    consultantCity: data.Account.City,
    consultantCulture: data.Account.Culture,
    consultantCountry: data.Account.Country,
    consultantEmail: data.Account.Email,
    consultantPhone: data.Account.PrimaryPhoneNumber,
    consultantTitle: data.Account.Title,
  }
  localStorage.setItem("consultant", JSON.stringify(dataParsed))
  return dataParsed
}

async function getConsultantData() {
  try{
    const consultantId = location.href.match(/twcId=(.*)/)?.[1]
    const consultantIdStorage = getLocalStorage("twcid")
    const consultantIdSessionStorage = JSON.parse(getLocalStorage("consultant"))?.consultantId
    const finalConsultantId =  consultantIdStorage || consultantIdSessionStorage || consultantId 

    if(!finalConsultantId || finalConsultantId === 'undefined') return
    const consultantString = await getConsultantDetails(finalConsultantId);
    return JSON.stringify(consultantString)
  } catch (error) {
    console.log('error', error)
    return null
  }
}
 

async function initPWSCheckout() {
  const getConsultant = getLocalStorage("consultant");
  const getConsultantSubdomain = await getConsultantData();
  const getParty = getLocalStorage("party");
  let consultant;
  if(getConsultantSubdomain) {
    consultant = JSON.parse(getConsultantSubdomain)
  } 
  else {
    consultant = JSON.parse(getConsultant);
  }
  const party = JSON.parse(getParty);

  document.addEventListener("page:load", updateAttributes());


}

document.onreadystatechange = () => {
  if (document.readyState === "interactive") {
    initPWSCheckout();
  }
};


function moveBackToConsultantSelect() {
  document.querySelector('.pws-consultant').style.display = 'none'
  document.querySelector('.pws-party').style.display = 'none'
  document.querySelector('.pws__party-connect').classList.add('hidden')
  if (localStorage.getItem('checkout_locale') === 'es') {
    document.querySelector('#pws-container-title').innerHTML = '¿Estás comprando con un representante?'
  }
  else {
    document.querySelector('#pws-container-title').innerHTML = 'Do you want to select a consultant?'
  }
  document.querySelector('#pws-container-title').classList.remove('hidden')
  document.querySelector('#consultant-menu').style.display = 'block'
  document.querySelector('.pws-consultant__change-button').classList.add('hidden')
  const radioButton =  document.querySelector('#yes-button-party')
  radioButton.checked = true 
  document.querySelector('#party-cards').classList.add('hidden')
  document.querySelector('#party-menu').classList.remove('hidden')
  partyList = []
  consultantList = []
  clearConsultantResults()
}

function moveBackToPartySelect() {
  document.querySelector('.pws-party').style.display = 'none'
  if (localStorage.getItem('checkout_locale') === 'es') {
    document.querySelector('#pws-container-title').innerHTML = '¿Estás comprando en una fiesta?'
  }
  else {
    document.querySelector('#pws-container-title').innerHTML = 'Do you want to select a party?'
  }
 
  document.querySelector('.pws__party-connect').classList.remove('hidden')
  document.querySelector('#party-menu').classList.remove('hidden')
  document.querySelector('#party-cards').classList.add('hidden')
  document.getElementById("continue_button").classList.add("hidden");
}

function continueButton(show) {
  const continueButton = document.getElementById("continue_button");
  if (show) {
    continueButton.classList.remove("hidden");
  } else {
    continueButton.classList.add("hidden");
  }
}

// consultant check and connect 
async function searchConsultantById(id) {
  if (!id.includes('US')) {
    id = `US-${id}`
  }
    var requestOptions = {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      redirect: 'follow'
    };

    return fetch(`https://soa.tupperware.com/twgb/shopify/jk/get/accountdetails/v1rs?Country=US&Offset=0&Size=50&AccountId=${id}`, requestOptions)
}

async function searchConsultantByName(name) {
  var requestOptions = {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
    redirect: 'follow'
  };

  return fetch(`https://soa.tupperware.com/twgb/shopify/jk/search/accountdetails/v1rs?Country=US&Offset=0&Size=50&Name=${name}`, requestOptions)
}

async function searchConsultantByEmail(email) {
  var requestOptions = {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
    redirect: 'follow'
  };

  return fetch(`https://soa.tupperware.com/twgb/shopify/jk/search/accountdetails/v1rs?Country=US&Offset=0&Size=50&Email=${email}`, requestOptions)

}

async function searchConsultantByPhone(phone) {
  var requestOptions = {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
    redirect: 'follow'
  };

  return fetch(`https://soa.tupperware.com/twgb/shopify/jk/search/accountdetails/v1rs?Country=US&Offset=0&Size=50&PhoneNumber=${phone}`, requestOptions)

}

function getAllConsultants(searchValue) {
Promise.all([
    searchConsultantById(searchValue),
    searchConsultantByEmail(encodeURIComponent(searchValue)),
    searchConsultantByName(searchValue),
    searchConsultantByPhone(searchValue)
  ]).then(responses => Promise.all(responses.map(response => response.json())))
    .then(data => {
      const [firstResult, ...rest] = data;
      if (firstResult.ResponseParameters.Status !== 'FAILURE' && firstResult.Account) {
        toggleSkeleton(false)
        document.getElementById('confirm_message').classList.remove('hidden')
        consultantList.push(firstResult.Account)
        addConsultantListener()
        appendResults() 
      }

      else if (rest.length > 0) {
        rest.forEach(result => {
          if(result.ResponseParameters.Status !== 'FAILURE' && result.Accounts?.Account) {
            toggleSkeleton(false)
            document.getElementById('confirm_message').classList.remove('hidden')
            consultantList.push(...result.Accounts.Account)
            addConsultantListener()
            appendResults()
          
          }
        })

        if (firstResult.ResponseParameters.Status !== 'FAILURE' && !firstResult.Account) {
          toggleSkeleton(false)
          const errorContainer = document.querySelector('#error-message')
          errorContainer.classList.remove('hidden')
        }
        
        if (consultantList.length === 0) {
          toggleSkeleton(false)
          const errorContainer = document.querySelector('#error-message')
          errorContainer.classList.remove('hidden')
        }
      }

    })
    .catch(error => {
        console.error('Error fetching data:', error);
    });
}


function appendPartyResults() {
  renderedPartyList = partyList.filter((party, index) => index < 6)
  const pageNumbers = Math.ceil(partyList.length / 6)
    renderedPartyList.forEach(party => {
      const partyCardHtml = partyCard(party);
      const partyContainer = document.getElementById('party-cards');
      partyContainer.appendChild(partyCardHtml);

      partyCardHtml.addEventListener('click', (event) => {
        if (event.target.id === 'confirm_party') {
          document.getElementById('continue_button').classList.remove('hidden');
        }
      });
    });
  
  if(pageNumbers > 1) {
    renderPartyPagination(pageNumbers)
  }
  else {
    document.querySelector('.party-pagination').innerHTML = ''
  }
}


function appendResults() {
  renderedConsultantList = consultantList.filter((consultant, index) => index < 6)
  const pageNumbers = Math.ceil(consultantList.length / 6)
  renderedConsultantList.forEach(consultant => {
    const consultantCardHtml = consultantCard(consultant)
    const consultantsContainer = document.getElementById('consultant-cards')
    consultantsContainer.appendChild(consultantCardHtml)
  })
  if(pageNumbers > 1) {
    renderPagination(pageNumbers)
  }
  else {
    document.querySelector('.pagination').innerHTML = ''
  }
}

function selectedPage(page) {
  const paginationButtons = document.querySelectorAll('.pagination__button');
  paginationButtons.forEach((button) => {
    button.classList.remove('active');
  });
  if (page) {
    const buttonsArray = Array.from(paginationButtons);
    const selectedButton = buttonsArray.find((button) => button.innerHTML == page);
    if (selectedButton) {
      selectedButton.classList.add('active');
    }
  }
}

function renderPartyPagination(pageNumbers) {
  const paginationContainer = document.querySelector('.party-pagination');
  paginationContainer.innerHTML = '';
  // First page button
  const firstPageButton = document.createElement('button');
  firstPageButton.innerHTML = '<';
  firstPageButton.className = 'pagination__button';
  firstPageButton.addEventListener('click', () => {
    renderPartyPage(1);
    selectedPage('1');
  });
  paginationContainer.appendChild(firstPageButton);

  // Page buttons
  for (let i = 1; i <= pageNumbers; i++) {
    const paginationButton = document.createElement('button');
    paginationButton.innerHTML = i;
    paginationButton.className = 'pagination__button';
    paginationButton.addEventListener('click', (event) => {
      renderPartyPage(i);
      selectedPage(event.target.innerHTML);
    });
    paginationContainer.appendChild(paginationButton);
  }
  selectedPage('1');
  // Last page button
  const lastPageButton = document.createElement('button');
  lastPageButton.innerHTML = '>';
  lastPageButton.className = 'pagination__button';
  lastPageButton.addEventListener('click', () => {
    renderPartyPage(pageNumbers);
    selectedPage(pageNumbers.toString());
  });
  paginationContainer.appendChild(lastPageButton);
  
  function renderPartyPage(page) {
    const partyContainer = document.getElementById('party-cards');
    partyContainer.innerHTML = '';
    const start = (page - 1) * 6;
    const end = start + 6;
    const pageParties = partyList.slice(start, end);
    pageParties.forEach((party) => {
      const partyCardHtml = partyCard(party);
      partyContainer.appendChild(partyCardHtml);
      partyCardHtml.addEventListener('click', (event) => {
        if (event.target.id === 'confirm_party') {
          document.getElementById('continue_button').classList.remove('hidden');
        }
      });
    });
    addPartyListener();
  }
}


function renderPagination(pageNumbers) {
  const paginationContainer = document.querySelector('.pagination');
  paginationContainer.innerHTML = '';
  // First page button
  const firstPageButton = document.createElement('button');
  firstPageButton.innerHTML = '<';
  firstPageButton.className = 'pagination__button';
  firstPageButton.addEventListener('click', () => {
    renderPage(1);
  });
  paginationContainer.appendChild(firstPageButton);

  // Page buttons
  for (let i = 1; i <= pageNumbers; i++) {
    const paginationButton = document.createElement('button');
    paginationButton.innerHTML = i;
    paginationButton.className = 'pagination__button';
    paginationButton.addEventListener('click', () => {
      renderPage(i);
    });
    paginationContainer.appendChild(paginationButton);
  }

  // Last page button
  const lastPageButton = document.createElement('button');
  lastPageButton.innerHTML = '>';
  lastPageButton.className = 'pagination__button';
  lastPageButton.addEventListener('click', () => {
    renderPage(pageNumbers);
  });
  paginationContainer.appendChild(lastPageButton);

  function renderPage(page) {
    const consultantsContainer = document.getElementById('consultant-cards');
    consultantsContainer.innerHTML = '';
    const start = (page - 1) * 6;
    const end = start + 6;
    const pageConsultants = consultantList.slice(start, end);
    pageConsultants.forEach((consultant) => {
      const consultantCardHtml = consultantCard(consultant);
      consultantsContainer.appendChild(consultantCardHtml);
    });

    // Add a different class and color for the current page clicked
    // const paginationButtons = document.querySelectorAll('.pagination__button');
    // paginationButtons.forEach((button) => {
    //   button.classList.remove('pagination__button--active');
    // });
    // paginationButtons[page - 1].classList.add('pagination__button--active');

    addConsultantListener();
  }
}

function showSelectedConsultant() {
  const consultantInformation = JSON.parse(getLocalStorage("consultant"));
  const noConsultant = document.querySelector('.pws-no-consultant');
  const showSelected = document.querySelector('.pws-consultant');
  const consultantName =  document.querySelector('#pws-consultant--name');
  const consultantSub = document.querySelector('#pws-consultant--sub');
  const consultantLocal = document.querySelector('#pws-consultant--local');
  const consultantButton = document.querySelector('.pws-consultant__change-button');
  consultantName.innerText = consultantInformation.consultantName;
  consultantLocal.innerText = `${consultantInformation.consultantCity}, ${consultantInformation.consultantState}`;
  consultantSub.innerText = consultantInformation.consultantTitle || consultantInformation.Title;
  noConsultant.style.display = 'none';
  showSelected.style.display = 'block';
  
}

async function showSelectedParty() {
  const partyContent = await getPartyByNumber(getLocalStorage("twpid"))
  const showSelected = document.querySelector('.pws-party');
  const partyName =  document.querySelector('#pws-party--name');
  const partyHostName = document.querySelector('#pws-party--hostname');
  const partyLocal = document.querySelector('#pws-party--local');
  const partyDate = document.querySelector('#pws-party--date');
  if (partyContent.City === null || partyContent.State === null) {
    document.querySelector("#pws-party--localContainer").classList.add('hidden');
  }
  partyName.innerText = partyContent.Name;
  partyHostName.innerText = partyContent.HostName;
  partyLocal.innerText = `${partyContent.City}, ${partyContent.State}`;
  partyDate.innerText = formatDate(partyContent.EndDate);
  showSelected.style.display = 'block';
}

function clearPartyResults() {
  const partyContainer = document.getElementById('party-cards')
  partyContainer.innerHTML = ''
  document.querySelector('.party-pagination').innerHTML = ''
  partyList = []

}

function selectConsultant(consultant) {
  localStorage.setItem('twcid', consultant.consultantId)
  document.querySelector('.pws-consultant').style.display = 'block'
  document.querySelector('#pws-consultant--initials').innerHTML = getInitials(consultant.consultantName)
  updateMessage(consultant.consultantName, "pws-consultant--name");
  updateMessage(consultant.consultantTitle, "pws-consultant--sub");
  updateMessage(`${consultant.consultantCity} ${consultant.consultantState}`, "pws-consultant--local");
  moveToPartySelect()
}

let consultant;
function addConsultantListener() {
  setTimeout(() => {
    const consultantCards = document.querySelectorAll('.consultant-card__confirm')
    consultantCards.forEach(button => {
      button.addEventListener('click', (event) => {
        consultant = {
          consultantId: event.target.dataset.consultantId,
          consultantName: event.target.parentElement.querySelector('h3').innerHTML,
          consultantCity: event.target.parentElement.querySelector('#consultant-city') ? event.target.parentElement.querySelector('#consultant-city').innerHTML : '',
          consultantState: event.target.parentElement.querySelector('#consultant-state') ? event.target.parentElement.querySelector('#consultant-state').innerHTML : '',
          consultantTitle: event.target.parentElement.querySelector('.consultant-card__subHeading') ? event.target.parentElement.querySelector('.consultant-card__subHeading').innerHTML : '',
        }
        selectConsultant(consultant)
        hideParty()
      })
    })
  }, 100);
}

function moveToPartySelect() {
  const partyRadios = document.querySelector('.pws__party-connect')
  partyRadios.classList.remove('hidden')
  document.querySelector('#pws-container-title').innerHTML = 'Do you want to select a party?'
  document.querySelector('#consultant-menu').style.display = 'none'
  document.querySelector('.pws-consultant__change-button').classList.remove('hidden')
  getParties()
}

function addPartyListener() {
  setTimeout(() => {
    const partyCards = document.querySelectorAll('.party-card__confirm')
    partyCards.forEach(button => {
      button.addEventListener('click', (event) => {
        selectedPartyId = event.target.dataset.partyId
        const selectedParty = getSelectedParty(selectedPartyId)
        selectParty(selectedParty)
      })
    })
  }, 1000)
}

async function getParties() {
  if (getLocalStorage('twpid') !== null) {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };
      const response = await fetch(`https://soa.tupperware.com/twgb/shopify/jk/get/partydetails/v1rs?Country=US&PartyNumber=${getLocalStorage('twpid')}`, requestOptions)
      const result = await response.json()
      const partyContainer = document.querySelector('.pws-party')
      if (result.Party) {
        partyList = result.Party

        // Check expiration date
        const expireDate = new Date(partyList.ExpireDate);
        const currentDate = new Date();
        if (expireDate < currentDate) {
          showModal();
          return;
        }

        const partyContainer = document.getElementById('party-cards');
        const partyCardHtml = partyCard(partyList);
        partyContainer.classList.remove('hidden')
        partyContainer.appendChild(partyCardHtml);
        partyCardHtml.addEventListener('click', (event) => {
          if (event.target.id === 'confirm_party') {
            document.getElementById('continue_button').classList.remove('hidden');
          }
        });
        addPartyListener()
      }
    } catch (error) {}
  } else {
    const radioButton =  document.querySelector('#yes-button-party')
    radioButton.checked = false
    try {
      var myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };
      const consultantId = getLocalStorage("twcid")
      const response = await fetch(`https://soa.tupperware.com/twgb/shopify/jk/search/partydetails/v1rs?Country=US&Offset=0&Size=100&ConsultantId=${consultantId}`, requestOptions)
      const result = await response.json()
      if(!result.Parties) {
        showNoPartiesMessage()
      } else {
        clearPartyResults()
        if (result.Parties.Party) {
          result.Parties.Party.sort((a, b) => new Date(b.EndDate) - new Date(a.EndDate))
          partyList = result.Parties.Party
          addPartyListener()
          appendPartyResults()
          
      }
    }
    } catch (error) {
    }
  }
}

function selectParty(party) {
  localStorage.setItem('twpid', party.Code)
  if (party.City === null || party.State === null) {
    document.querySelector("#pws-party--localContainer").classList.add('hidden');
  }

  updateMessage(party.Name, "pws-party--name");
  updateMessage(party.HostName, "pws-party--hostname");
  updateMessage(`${party.City}, ${party.State}`, "pws-party--local");
  updateMessage(formatDate(party.EndDate), "pws-party--date");
  moveToEnd()
}

function moveToEnd() {
  const partyMenu = document.querySelector('#party-menu')
  partyMenu.classList.add('hidden')
  const titleElement = document.querySelector('#pws-container-title')
  titleElement.classList.add('hidden')
  document.querySelector('.pws-party').style.display = 'block'
  document.querySelector('.pws-party__change-button').classList.remove('hidden')
}

function getSelectedParty(selectedPartyId) {
  if (Array.isArray(partyList)) {
    const selectedParty = partyList.find(party => party.Code === selectedPartyId)
    return selectedParty
  }
  return partyList
}

function showNoPartiesMessage() {
  document.querySelector('.party-cards-empty').classList.remove('hidden')
}

function getConsultantPhone(consultantId) {
  const consultantPhone = consultantList.find(consultant => consultant.Code === consultantId).PrimaryPhoneNumber
  return consultantPhone
}

function partyCard(party) {
  const formattedEndDate = formatDate(party.EndDate);
  const container = document.createElement('div');
  container.className = 'party-card__container';
  container.innerHTML = `
  <div class="party-card___content">
    <div class="party-information">
    <h3>${party.HostName}</h3>
    <h4 class="party-card__subHeading">${party.Name}</h4>

    <p>${party.City && party.State ? `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clip-path="url(#clip0_591_1505)">
          <path d="M7.99935 8.00016C7.26602 8.00016 6.66602 7.40016 6.66602 6.66683C6.66602 5.9335 7.26602 5.3335 7.99935 5.3335C8.73268 5.3335 9.33268 5.9335 9.33268 6.66683C9.33268 7.40016 8.73268 8.00016 7.99935 8.00016ZM11.9993 6.80016C11.9993 4.38016 10.2327 2.66683 7.99935 2.66683C5.76602 2.66683 3.99935 4.38016 3.99935 6.80016C3.99935 8.36016 5.29935 10.4268 7.99935 12.8935C10.6993 10.4268 11.9993 8.36016 11.9993 6.80016ZM7.99935 1.3335C10.7993 1.3335 13.3327 3.48016 13.3327 6.80016C13.3327 9.0135 11.5527 11.6335 7.99935 14.6668C4.44602 11.6335 2.66602 9.0135 2.66602 6.80016C2.66602 3.48016 5.19935 1.3335 7.99935 1.3335Z" fill="black"/>
        </g>
        <defs>
          <clipPath id="clip0_591_1505">
            <rect width="16" height="16" fill="white"/>
          </clipPath>
        </defs>
      </svg> ${party.City}, ${party.State}` : ''}</p>
    <p><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <g clip-path="url(#clip0_591_1510)">
        <path d="M3.75861 6.41683H5.0549V7.71313H3.75861V6.41683ZM12.8327 3.17609V12.2502C12.8327 12.9631 12.2493 13.5465 11.5364 13.5465H2.46231C1.74287 13.5465 1.16602 12.9631 1.16602 12.2502L1.1725 3.17609C1.1725 2.46313 1.74287 1.87979 2.46231 1.87979H3.11046V0.583496H4.40676V1.87979H9.59194V0.583496H10.8882V1.87979H11.5364C12.2493 1.87979 12.8327 2.46313 12.8327 3.17609ZM2.46231 4.47239H11.5364V3.17609H2.46231V4.47239ZM11.5364 12.2502V5.76868H2.46231V12.2502H11.5364ZM8.94379 7.71313H10.2401V6.41683H8.94379V7.71313ZM6.3512 7.71313H7.6475V6.41683H6.3512V7.71313Z" fill="black"/>
      </g>
      <defs>
        <clipPath id="clip0_591_1510">
          <rect width="14" height="14" fill="white"/>
        </clipPath>
      </defs>
    </svg> ${formattedEndDate}</p>
    <button data-party-id="${party.Code}" class="party-card__confirm" id="confirm_party" >Confirm</button>
    `
  return container;
}

function consultantCard(consultant) {
  const container = document.createElement('div');
  container.className = 'consultant-card__container';
  container.innerHTML = `
  <div class="consultant-card___content">
    <div class="consultant-image">
      <p class="consultant-initials">${getInitials(consultant.Name)}</p>
    </div>
    <div class="consultant-information">
    <h3>${consultant.Name.toLowerCase()}</h3>
    <h4 class="consultant-card__subHeading">${consultant.Title ? consultant.Title : ''}</h4>
    </div>
  </div>
  <div class="consultant-card__info">
      <p>
          ${consultant.City || consultant.State ? `
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <g clip-path="url(#clip0_547_848)">
                <path d="M7.99935 7.99967C7.26602 7.99967 6.66602 7.39967 6.66602 6.66634C6.66602 5.93301 7.26602 5.33301 7.99935 5.33301C8.73268 5.33301 9.33268 5.93301 9.33268 6.66634C9.33268 7.39967 8.73268 7.99967 7.99935 7.99967ZM11.9993 6.79967C11.9993 4.37967 10.2327 2.66634 7.99935 2.66634C5.76602 2.66634 3.99935 4.37967 3.99935 6.79967C3.99935 8.35967 5.29935 10.4263 7.99935 12.893C10.6993 10.4263 11.9993 8.35967 11.9993 6.79967ZM7.99935 1.33301C10.7993 1.33301 13.3327 3.47967 13.3327 6.79967C13.3327 9.01301 11.5527 11.633 7.99935 14.6663C4.44602 11.633 2.66602 9.01301 2.66602 6.79967C2.66602 3.47967 5.19935 1.33301 7.99935 1.33301Z" fill="black"/>
              </g>
              <defs>
                <clipPath id="clip0_547_848">
                  <rect width="16" height="16" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <span id="consultant-city">${consultant.City ? consultant.City : ''}</span>
            <span id="consultant-state">${consultant.State ? `, ${consultant.State}` : '' }</span>
          ` : ''}
        </p>
        <p><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <g clip-path="url(#clip0_591_1510)">
          <path d="M3.75861 6.41683H5.0549V7.71313H3.75861V6.41683ZM12.8327 3.17609V12.2502C12.8327 12.9631 12.2493 13.5465 11.5364 13.5465H2.46231C1.74287 13.5465 1.16602 12.9631 1.16602 12.2502L1.1725 3.17609C1.1725 2.46313 1.74287 1.87979 2.46231 1.87979H3.11046V0.583496H4.40676V1.87979H9.59194V0.583496H10.8882V1.87979H11.5364C12.2493 1.87979 12.8327 2.46313 12.8327 3.17609ZM2.46231 4.47239H11.5364V3.17609H2.46231V4.47239ZM11.5364 12.2502V5.76868H2.46231V12.2502H11.5364ZM8.94379 7.71313H10.2401V6.41683H8.94379V7.71313ZM6.3512 7.71313H7.6475V6.41683H6.3512V7.71313Z" fill="black"/>
        </g>
        <defs>
          <clipPath id="clip0_591_1510">
            <rect width="14" height="14" fill="white"/>
          </clipPath>
        </defs>
      </svg>${localStorage.getItem('checkout_locale') === 'es' ?   (consultant.NumberOfYearsExp !== '0' ?  '  ' + consultant.NumberOfYearsExp + ' Años de experiencia' : 'Menos de 1 año de experiencia') : (consultant.NumberOfYearsExp !== '0' ? ' ' + consultant.NumberOfYearsExp + ' years of experience' : 'Less than 1 year of experience') }</p>
        <p>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clip-path="url(#clip0_547_860)">
              <path d="M7.99398 1.33301C4.31398 1.33301 1.33398 4.31967 1.33398 7.99967C1.33398 11.6797 4.31398 14.6663 7.99398 14.6663C11.6807 14.6663 14.6673 11.6797 14.6673 7.99967C14.6673 4.31967 11.6807 1.33301 7.99398 1.33301ZM12.614 5.33301H10.6473C10.434 4.49967 10.1273 3.69967 9.72732 2.95967C10.954 3.37967 11.974 4.23301 12.614 5.33301ZM8.00065 2.69301C8.55398 3.49301 8.98732 4.37967 9.27398 5.33301H6.72732C7.01398 4.37967 7.44732 3.49301 8.00065 2.69301ZM2.84065 9.33301C2.73398 8.90634 2.66732 8.45967 2.66732 7.99967C2.66732 7.53967 2.73398 7.09301 2.84065 6.66634H5.09398C5.04065 7.10634 5.00065 7.54634 5.00065 7.99967C5.00065 8.45301 5.04065 8.89301 5.09398 9.33301H2.84065ZM3.38732 10.6663H5.35398C5.56732 11.4997 5.87398 12.2997 6.27398 13.0397C5.04732 12.6197 4.02732 11.773 3.38732 10.6663ZM5.35398 5.33301H3.38732C4.02732 4.22634 5.04732 3.37967 6.27398 2.95967C5.87398 3.69967 5.56732 4.49967 5.35398 5.33301ZM8.00065 13.3063C7.44732 12.5063 7.01398 11.6197 6.72732 10.6663H9.27398C8.98732 11.6197 8.55398 12.5063 8.00065 13.3063ZM9.56065 9.33301H6.44065C6.38065 8.89301 6.33398 8.45301 6.33398 7.99967C6.33398 7.54634 6.38065 7.09967 6.44065 6.66634H9.56065C9.62065 7.09967 9.66732 7.54634 9.66732 7.99967C9.66732 8.45301 9.62065 8.89301 9.56065 9.33301ZM9.72732 13.0397C10.1273 12.2997 10.434 11.4997 10.6473 10.6663H12.614C11.974 11.7663 10.954 12.6197 9.72732 13.0397ZM10.9073 9.33301C10.9607 8.89301 11.0007 8.45301 11.0007 7.99967C11.0007 7.54634 10.9607 7.10634 10.9073 6.66634H13.1607C13.2673 7.09301 13.334 7.53967 13.334 7.99967C13.334 8.45967 13.2673 8.90634 13.1607 9.33301H10.9073Z" fill="black"/>
            </g>
            <defs>
              <clipPath id="clip0_547_860">
                <rect width="16" height="16" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          ${consultant.Culture}
        </p>
  </div>
    <button data-consultant-id="${consultant.Code}" class="consultant-card__confirm" id="confirm_consultant" >${localStorage.getItem('checkout_locale') === 'es' ? 'Confirmar' : 'Confirm' }</button>
  `;
  return container;
}

async function getPartyByNumber (partyNumber) {
  var myHeaders = new Headers();
  myHeaders.append("Accept", "application/json");

  var requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
  };
  
  const response = await fetch(`https://soa.tupperware.com/twgb/shopify/jk/get/partydetails/v1rs?Country=US&PartyNumber=${partyNumber}`, requestOptions)
  const result = await response.json()
  return result?.Party
} 